var exports = {
  "k": "x620889e6--2cf476--container",
  "X": "x620889e6--2cf476--user-type-container",
};

module.exports = exports;
